import { TextFieldStyled } from '@nike/nike-design-system-components';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

const Input = forwardRef(function Input(
  {
    error,
    errorMessage,
    id,
    isDisabled,
    isRequired,
    label,
    maxLength,
    minLength,
    onBlur,
    onChange,
    onFocus,
    showCharacterCount,
    type,
    value,
    TrailingIcon,
    onIconClick,
    style,
    className,
    inputProps,
    dateInputOnChange,
  },
  ref,
) {
  return (
    <TextFieldStyled
      error={error || (isRequired && !value)}
      errorMessage={errorMessage}
      id={id}
      label={label}
      maxLength={maxLength}
      minLength={minLength}
      name={id}
      readOnly={isDisabled}
      requiredIndicator={isRequired ? '*' : ''}
      showCharacterCount={showCharacterCount}
      type={type}
      value={value}
      onBlur={onBlur}
      onChange={
        typeof dateInputOnChange === 'function'
          ? dateInputOnChange
          : ({ target: { value: newValue } }) => {
              onChange(newValue);
            }
      }
      onFocus={onFocus}
      TrailingIcon={TrailingIcon}
      onIconClick={onIconClick}
      ref={ref}
      style={style}
      className={className}
      inputProps={inputProps}
    />
  );
});

Input.defaultProps = {
  error: false,
  errorMessage: '',
  isDisabled: false,
  isRequired: false,
  maxLength: 100,
  minLength: undefined,
  onBlur: () => {},
  onFocus: () => {},
  showCharacterCount: false,
  type: 'text',
  TrailingIcon: null,
  onIconClick: () => {},
  style: {},
  className: '',
  inputProps: undefined,
  dateInputOnChange: false,
};

Input.propTypes = {
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  showCharacterCount: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  TrailingIcon: PropTypes.node,
  onIconClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  inputProps: PropTypes.object,
  dateInputOnChange: PropTypes.func,
};

export default Input;
